module.exports = __webpack_public_path__ + "img/dnd-frame1.53618a37.png";